import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function principalCardSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page7Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page7Overlay.value = true;
  const option = ccFormValue.value.principalDetails.deliveryOption == "H";
  const requestModel = {
    dropOffStep: "S8",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      principalCardDetail: {
        name: ccFormValue.value.principalDetails.name,
        deliveryOption: ccFormValue.value.principalDetails.deliveryOption,
        branchName: ccFormValue.value.principalDetails.branch,
        branchValue: ccFormValue.value.principalDetails.branchValue,
        deliveryAddress: {
          addressLine1:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.address1
              : "",
          addressLine2:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.address2
              : "",
          addressLine3:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.address3
              : "",
          postcode:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.postCode
              : "",
          city:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.city
              : "",
          state:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.state
              : "",
        },
        billingAddress:
          ccFormValue.value.principalDetails.eStatement == "No"
            ? ccFormValue.value.principalDetails.billingAddress
            : "",
        eStatement:
          ccFormValue.value.principalDetails.eStatement == "Yes" ? true : false,
        jcklClubBillPeriod:
          ccFormValue.value.principalDetails.jcklClubBillPeriod,
        jcklFeeAmount: ccFormValue.value.principalDetails.jcklFeeAmount,
      },
    },
  };
  MasterService.pageSubmit(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        ccFormValue.value.dropOffStep = 9;
        if (ccFormValue.value.summarySetting.principalCardDetailsJump == true) {
          if (ccFormValue.value.summarySetting.uploadDocumentsJump == true) {
            ccFormValue.value.summarySetting.principalCardDetailsJump = false;
            jumpStep(8, "", "7");
            page7Overlay.value = false;
          } else {
            ccFormValue.value.summarySetting.principalCardDetailsJump = false;
            jumpStep(12, "", "7");
            page7Overlay.value = false;
          }
        } else {
          jumpStep(8, "", "7");
          page7Overlay.value = false;
        }
      } else {
        page7Overlay.value = false;
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page7Overlay.value = false;
    });
}
